export const DofSidebarData = [
    {
        title: 'Dashboard',
        path: '/admin/dashboard',
    },
    {
        title: 'Membership',
        subNav: [
            {
                title: 'Global Members',
                path: '/global_members',
            },
            {
                title: 'Active Members',
                path: '/active_members',
            },
            {
                title: 'InActive Members',
                path: '/inactive_members',
            },
        ]
    },
    {
        title: 'Accounts',
        path: '/#',
        subNav: [
            {
                title: 'Receipts',
                path: '/#',
                subNav: [
                    {
                        title: 'Manual Receipt',
                        path: '/manual_receipt',
                    },
                ],
            },
            {
                title: 'Payments',
                path: '/#',
                subNav: [
                    {
                        title: 'Payment Transactions',
                        path: '/payment_transactions',
                    },
                    {
                        title: 'Payment Clearance',
                        path: '/payment_clearance',
                    },
                    {
                        title: 'Payment Types',
                        path: '/payment_types',
                    },
                    {
                        title: 'Yearly Payments',
                        path: '/yearly_payments',
                    },
                ],
            },
            {
                title: 'Ledgers',
                path: '/#',
                subNav: [
                    {
                        title: 'Ledger Accounts',
                        path: '/ledger_accounts',
                    },
                    {
                        title: 'Yearly Ledgers',
                        path: '/yearly_ledgers',
                    },
                ],
            },
            {
                title: 'Expenditure',
                path: '/#',
                subNav: [
                    {
                        title: 'Expenditure Items',
                        path: '/expenditure',
                    },
                ],
            },
            {
                title: 'Revenue',
                path: '/#',
                subNav: [
                    {
                        title: 'Revenue Items',
                        path: '/revenue',
                    },
                ],
            },
			{
				title: "Accounts Reports",
				path: "/#",
				subNav: [
					{
						title: "2M2 Payments",
						path: "/2m2_payments",
					},
					{
						title: "Mandatory Payments",
						path: "/mandatory_payments_report",
					},
					{
						title: "Ledger Balances",
						path: "/ledger_balances",
					},
				],
			},
        ]
    },
    {
        title: 'Log Out',
        path: '/admin_logout',
    },

];

